export default function getDomainListPathFromQueryReduxUtil (domainListPath, query) {
  if (!query) {
    return domainListPath
  }
  return `${domainListPath}.byQuery.${query}`
}
